import { Component, OnInit } from '@angular/core';
import { RoleService } from 'src/app/services/role.service';
import { AbilityService } from 'src/app/services/ability.service';
import { Role } from 'src/app/models/role';
import { Ability } from 'src/app/models/ability';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-role-ability',
  templateUrl: './role-ability.component.html',
  styleUrls: ['./role-ability.component.css']
})
export class RoleAbilityComponent implements OnInit {

  constructor(private roleServ:RoleService, private abilityServ:AbilityService, private modalService:NgbModal) { }

  loading:boolean = false;
  roles:Role[] = [];
  role:Role = new Role();
  abilities:Ability[] = [];
  ability:Ability = new Ability();

  ngOnInit() {
    this.loading = true;
    this.roleServ.getRoles().then(roles => this.roles = roles);
    this.abilityServ.getAbilities().then(abilities => {
      this.abilities = abilities;
      this.loading = false;
    });
  }

  selectR(modal, role?) {
    if(role) {
      this.role = role;
    } else {
      this.role = new Role();
    }

    this.modalService.open(modal, { size: 'lg' });
  }

  selectA(modal, ability?) {
    if(ability) {
      this.ability = ability;
    } else {
      this.role = new Role();
    }

    this.modalService.open(modal, { size: 'lg' });
  }

  storeRole(event) {
    event.preventDefault();

    this.loading = true;
    this.roleServ.postRole(this.role).then(role => {
      this.roles.push(role);
      this.loading = false;
    });
  }

  storeAbility(event) {
    event.preventDefault();

    this.loading = true;
    this.abilityServ.postAbility(this.ability).then(ability => {
      this.abilities.push(ability);
      this.loading = false;
    });
  }

  updateRole(event) {
    event.preventDefault();
    
    this.loading = true;
    this.roleServ.putRole(this.role).then(role => {
      this.loading = false;
    });
  }

  updateAbility(event) {
    event.preventDefault();

    this.loading = true;
    this.abilityServ.putAbility(this.ability).then(ability => {
      this.loading = false;
    });
  }

}
